import { ChakraProvider, ChakraProviderProps } from '~/design_system'
import { useIsSanaRebrandEnabled } from '~/theme/useIsSanaRebrandEnabled'
import { workdayThemeLegacyVisualTokens, workdayThemeSanaRebrand } from '~/theme'

/**
 * ChakraProvider with Canvas v4 shape/depth theme tokens only when `sana_rebrand_enabled` is on
 * (matches `GlobalCSSVariables` / legacy vs Sana CSS split).
 */
export function ThemedChakraProvider({ theme: themeOverride, ...props }: ChakraProviderProps) {
  const defaultTheme: ChakraProviderProps['theme'] = useIsSanaRebrandEnabled()
    ? workdayThemeSanaRebrand
    : workdayThemeLegacyVisualTokens
  return <ChakraProvider {...props} theme={themeOverride ?? defaultTheme} />
}
